import {
  GET_REGIONAL_NATIONAL_LEVEL,
  GET_REGIONAL_NATIONAL_LEVEL_ERROR,
  GET_REGIONAL_NATIONAL_LEVEL_SUCCESS,
  GET_REGIONAL_PROVIDERS_SIZE,
  GET_REGIONAL_PROVIDERS_SIZE_ERROR,
  GET_REGIONAL_PROVIDERS_SIZE_SUCCESS
} from './RegionalAmountsTradedSection.actions'

const regionalAmountsTradedSectionState = {
  error: null,
  loading: false,
  nationalLevel: { csv: [], data: [], totalAmount: 0, totalAmountUSD: 0 },
  providersSize: { csv: [], data: [], totalAmount: 0, totalAmountUSD: 0 }
}

/**
 * The regional amounts traded section's reducer.
 */
const regionalAmountsTradedSectionReducer = (state = regionalAmountsTradedSectionState, { payload, type }) => {
  switch (type) {
    case GET_REGIONAL_NATIONAL_LEVEL:
    case GET_REGIONAL_PROVIDERS_SIZE: {
      return { ...state, loading: true }
    }
    case GET_REGIONAL_NATIONAL_LEVEL_ERROR:
    case GET_REGIONAL_PROVIDERS_SIZE_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_REGIONAL_NATIONAL_LEVEL_SUCCESS: {
      return { ...state, loading: false, nationalLevel: { ...state.nationalLevel, ...payload } }
    }
    case GET_REGIONAL_PROVIDERS_SIZE_SUCCESS: {
      return { ...state, loading: false, providersSize: { ...state.providersSize, ...payload } }
    }
    default: {
      return state
    }
  }
}

export default regionalAmountsTradedSectionReducer
